<template>
  <div class="modal-mask">

    <div class="modal-wrapper">

      <div class="modal-container">

        <button class="icon close-icon" @click="$emit('close')"><svg><use xlink:href="assets/svg/symbols.svg#close-note">
          <title>Cancel</title>
        </use></svg></button>

        <div class="modal-header">
          <h3>Reset Account Password</h3>
        </div>

        <div class="modal-body" >
          <form v-if="!success" @submit.prevent="resetPassoword">
            <p>Enter your account email to get a reset email sent to you and follow the instructions in the email.</p>
            <p class="error-msg" v-if="errors.length">
              <b>Please correct the following issue(s):</b>
              <ul>
                <li :key="error.substr(0,10)" v-for="error in errors">{{ error }}</li>
              </ul>
            </p>
            <input type="email" v-model="email" placeholder="Account Email">
          </form>
          <p v-if="success">A email has been sent to you that will allow you to reset the password for your account.</p>
        </div>

        <div class="modal-footer">
          <button class="modal-optional-button" @click="$emit('close')">
            {{success ? 'Close' : 'Cancel'}}
          </button>
          <button v-if="!success" class="modal-default-button" @click="resetPassword">Reset Password</button>
        </div>

      </div>

    </div>

    <div class="loading-mask" v-if="isLoading"><span>{{loadingMessage}}</span></div>

  </div>
</template>

<script>

  export default {

    data() {
      return {
        email:'',
        isLoading: false,
        loadingMessage:'Sending Reset Email...',
        errors:[],
        success: false
      }
    },

    mounted() {
      console.log('ResetPasswordDialog.mounted()');
    },

    methods: {
      resetPassword() {
        console.warn('ResetPasswordDialog.resetPassword()');
        let valid = RegExp(/^.+@.+\..+$/).test(this.email);
        this.errors = [];
        if (this.email && valid) {
          this.isLoading = true;
          this.$firebase.auth().sendPasswordResetEmail(this.email)
            .then(() => {
              this.isLoading = false;
              this.success = true;
            })
        } else {
          this.errors.push('You must enter a valid email address.')
        }
      },
      handleError(err) {
        console.warn('ResetPasswordDialog.handleError()');
        console.dir(err);
        this.isLoading = false;
        if (err.code ==='auth/wrong-password') {
          this.errors.push('Your password Current Password you entered was not valid');
        }
      }
    }
  };
</script>

<style scoped>
  .modal-mask .modal-container {
    width: 450px;
    position: relative;
  }
  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .modal-header * {
    display: inline-block;
    line-height: 50px;
  }
  .action-icon {
    float: right;
    vertical-align: middle;
  }
  input {
    display: block;
    margin: 10px auto;
    min-width: 200px;
  }
  .single-large {
    display: block;
    margin: 30px auto;
    padding: 0.5rem 1.5rem;
  }
</style>
